export default "__VITE_ASSET__B7d7ecZD__"